/**
 * useChartExpand — Lightweight hook for managing chart expand/collapse state.
 *
 * Returns:
 *   isOpen   {bool}  — whether the modal is open
 *   open     {fn}    — open the modal
 *   close    {fn}    — close the modal
 *   toggle   {fn}    — toggle open/close
 */
import { useState, useCallback } from 'react';

const useChartExpand = (initialOpen = false) => {
  const [isOpen, setIsOpen] = useState(initialOpen);

  const open   = useCallback(() => setIsOpen(true),  []);
  const close  = useCallback(() => setIsOpen(false), []);
  const toggle = useCallback(() => setIsOpen(v => !v), []);

  return { isOpen, open, close, toggle };
};

export default useChartExpand;
